// src/lib/api/userSearchApi.ts

import { getApiClient } from './client';

export interface UserSearchResult {
    id: string;
    email?: string;
    first_name?: string;
    last_name?: string;
    picture_url?: string;
    role?: string;
}

const searchUsers = async (query: string, limit: number = 10): Promise<UserSearchResult[]> => {
    if (!query || query.length < 2) return [];
    try {
        const data = await getApiClient().get<UserSearchResult[]>('/api/users/search', {
            params: { query, limit }
        });
        return data || [];
    } catch {
        return [];
    }
};

export const userSearchApi = { searchUsers };
